.grid {
  height: 450px;
  max-width: calc(100% - 40px);
  margin-left: 20px;
}
